'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');

/* eslint-disable max-len */
var REGEX_IP = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
var REGEX_IP_OR_CIDR = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;
/* eslint-enable max-len */

module.exports = buildSimpleValidator(function (value, validationOptions) {
  var allowCidr = validationOptions.allowCidr === true;

  return allowCidr ? REGEX_IP_OR_CIDR.test(value) : REGEX_IP.test(value);
}, function (_value, validationOptions) {
  var allowCidr = validationOptions.allowCidr === true;

  return allowCidr ? 'Value must be a valid IP address or CIDR block' : 'Value must be a valid IP address';
});